"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import LiveBlink from "@/components/ui/LiveBlink";
import { isLiveBlogValue } from "@/lib/liveBlog";
import { useRouter } from "next/navigation";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { getTimeAgo, getSectionUrl, toFieldString } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string | boolean;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  category?: FieldConfig;
  sectionUrl?: string;
  slug?: string;
  templatetype?: FieldConfig;
  isliveblog?: FieldConfig;
};
export const VerticalCategoryNewsSmall = t0 => {
  const $ = _c(42);
  const {
    title: t1,
    timeAgo: t2,
    category: t3,
    sectionUrl,
    slug,
    templatetype: t4,
    isliveblog: t5
  } = t0;
  const title = t1 === undefined ? {
    hidden: false,
    value: "\u0BAF\u0BBE\u0BB0\u0BCD \u0B95\u0BAE\u0BB2\u0BBF\u0BA9\u0BCD \u0BAA\u0BC6\u0BB0\u0BBF\u0BAF \u0BB0\u0B9A\u0BBF\u0B95\u0BB0\u0BCD? \u0B87\u0BA8\u0BCD\u0BA4 \u0B9A\u0BA8\u0BCD\u0BA4\u0BC8\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0B9A\u0B9F\u0BCD\u0B9F\u0BC8 \u0B95\u0BBF\u0BB4\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1: \u0BB2\u0BCB\u0B95\u0BC7\u0BB7\u0BCD \u0BAA\u0BC1\u0B95\u0BB4\u0BCD\u0BA8\u0BCD\u0BA4 \u0B95\u0BCA\u0BB3\u0BA4\u0BCD\u0BA4\u0BAE\u0BCD \u0BAE\u0BC7\u0BA9\u0BA9\u0BCD!",
    customClass: ""
  } : t1;
  const timeAgo = t2 === undefined ? {
    hidden: false,
    value: "1 hour ago",
    customClass: ""
  } : t2;
  let t6;
  if ($[0] !== t3) {
    t6 = t3 === undefined ? {
      hidden: false,
      value: "India",
      customClass: ""
    } : t3;
    $[0] = t3;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const category = t6;
  let t7;
  if ($[2] !== t4) {
    t7 = t4 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t4;
    $[2] = t4;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const templatetype = t7;
  let t8;
  if ($[4] !== t5) {
    t8 = t5 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t5;
    $[4] = t5;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const isliveblog = t8;
  const router = useRouter();
  const titleValue = toFieldString(title?.value);
  const timeAgoValue = getTimeAgo(toFieldString(timeAgo?.value));
  const t9 = category?.value;
  let t10;
  if ($[6] !== t9) {
    t10 = toFieldString(t9);
    $[6] = t9;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const categoryValue = t10;
  let t11;
  if ($[8] !== isliveblog?.value || $[9] !== templatetype?.value) {
    t11 = isLiveBlogValue(templatetype?.value) || isLiveBlogValue(isliveblog?.value);
    $[8] = isliveblog?.value;
    $[9] = templatetype?.value;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  const isLiveBlog = t11;
  let t12;
  if ($[11] !== sectionUrl) {
    t12 = getSectionUrl(sectionUrl);
    $[11] = sectionUrl;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  const sectionUrlValue = t12;
  const truncateTitle = _temp;
  let t13;
  if ($[13] !== router || $[14] !== sectionUrlValue) {
    t13 = e => {
      if (sectionUrlValue) {
        e.preventDefault();
        e.stopPropagation();
        router.push(sectionUrlValue);
      }
    };
    $[13] = router;
    $[14] = sectionUrlValue;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  const handleCategoryClick = t13;
  const t14 = "flex flex-col overflow-hidden p-4 gap-4";
  const t15 = "flex flex-col gap-3 h-auto justify-between";
  let t16;
  if ($[16] !== category?.customClass || $[17] !== category?.hidden || $[18] !== categoryValue || $[19] !== handleCategoryClick || $[20] !== sectionUrlValue) {
    t16 = !category?.hidden && (sectionUrlValue ? <span className={`text-11-tamil-600 text-012061 uppercase tracking-wide hover:underline cursor-pointer ${category?.customClass || ""}`} onClick={handleCategoryClick}>{categoryValue}</span> : <p className={`text-11-tamil-600 text-012061 uppercase tracking-wide ${category?.customClass || ""}`}>{categoryValue}</p>);
    $[16] = category?.customClass;
    $[17] = category?.hidden;
    $[18] = categoryValue;
    $[19] = handleCategoryClick;
    $[20] = sectionUrlValue;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  const t17 = !title?.hidden && <p className={`text-16-tamil-700 md:text-14-tamil-600 leading-[1.4] text-1B1B1B ${title?.customClass || ""}`}>{isLiveBlog && <LiveBlink />}{truncateTitle(titleValue)}</p>;
  let t18;
  if ($[22] !== t16 || $[23] !== t17) {
    t18 = <div>{t16}{t17}</div>;
    $[22] = t16;
    $[23] = t17;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== timeAgo?.customClass || $[26] !== timeAgo?.hidden || $[27] !== timeAgoValue) {
    t19 = !timeAgo?.hidden && <span className={`text-12-tamil-500 text-1B1B1B ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[25] = timeAgo?.customClass;
    $[26] = timeAgo?.hidden;
    $[27] = timeAgoValue;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  const t20 = slug ? `/${slug}` : undefined;
  let t21;
  if ($[29] !== slug || $[30] !== t20 || $[31] !== titleValue) {
    t21 = <div className="flex gap-3"><MessageIcon id="message-icon-2" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} articleUrl={t20} /></div>;
    $[29] = slug;
    $[30] = t20;
    $[31] = titleValue;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== t19 || $[34] !== t21) {
    t22 = <div className="flex justify-between items-center">{t19}{t21}</div>;
    $[33] = t19;
    $[34] = t21;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== t18 || $[37] !== t22) {
    t23 = <div className={t14}><div className={t15}>{t18}{t22}</div></div>;
    $[36] = t18;
    $[37] = t22;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  const content = t23;
  if (slug) {
    const t24 = `/${slug}`;
    let t25;
    if ($[39] !== content || $[40] !== t24) {
      t25 = <Link href={t24} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[39] = content;
      $[40] = t24;
      $[41] = t25;
    } else {
      t25 = $[41];
    }
    return t25;
  }
  return content;
};
function _temp(text, t0) {
  const maxLines = t0 === undefined ? 4 : t0;
  const maxChars = 45 * maxLines;
  if (text.length <= maxChars) {
    return text;
  }
  return text.slice(0, maxChars - 3) + "...";
}